import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Button, Center, Flex, Text } from '@chakra-ui/react';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { NotificationLink } from '../../components/NotificationLink';
import { NotificationTime } from '../../components/Time';
import { Recording01 } from '@kula-ai/icons-core';

const CandidateUndoNoShow = ({ notification = {}, onClose = () => {} }) => {
  const [markAsRead] = useMarkAsReadMutation();
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  const { candidate, done_by, interview_name, interview_url, ats_application } =
    data;
  const { url: applicationUrl } = ats_application;

  const { name: doneByNone } = done_by;
  const { name: candidateName, url } = candidate;
  const contact_id = url.split('/').pop();
  const interview_id = interview_url.split('/').pop();

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="pastel-2-light">
        <Recording01
          size={16}
          color="var(--kula-colors-pastel-2-dark)"
          className="kula-icon"
        />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
        <Text>
          <Text as="span" size="sm-semi-bold">
            {doneByNone}
          </Text>
          <Text as="span" fontSize="sm">
            {' '}
            undid the no-show marking for{' '}
          </Text>
          <Text as="span" size="sm-semi-bold">
            <NotificationLink
              to={`/candidates/${contact_id}`}
              label={candidateName}
              onClose={onClose}
              notification={notification}
            />
          </Text>
          <Text as="span" fontSize="sm">
            {' '}
            for the{' '}
          </Text>
          <Text as="span" size="sm-semi-bold">
            <NotificationLink
              to={`/interviews/${interview_id}`}
              label={interview_name}
              onClose={onClose}
              notification={notification}
            />
          </Text>
          <Text as="span" fontSize="sm">
            {' '}
            interview
          </Text>
        </Text>
        <NotificationTime notification={notification} />
        <Button
          w="fit-content"
          variant="ats-primary"
          borderRadius="8px"
          onClick={() => {
            markAsRead({ id: notification?.id });
            window.open(applicationUrl, '_self');
            onClose();
          }}
          maxH="34px"
          data-test-id="view-scorecard-button"
        >
          Go to candidate
        </Button>
      </Flex>
    </Flex>
  );
};

export const CandidateUndoNoShowNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <CandidateUndoNoShow notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
